import Popupz from "../atoms/Popupz";
import Inputz from "../atoms/Inputz";
import Buttonz from "../atoms/Buttonz";
import { login as pbLogin } from "../../auth/authApi";
import { pocketBaseErrorMessage } from "../../auth/errors";
import { validateLogin } from "../../auth/validation";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  validationPopup,
  showForgotPasswordPopup,
  setUserToken,
} from "../../redux/actions";

function LoginPopup({ onClose }) {
  const [formData, setFormData] = useState({
    identity: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    identity: false,
    password: false,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e;

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const { errors: vErr } = validateLogin({
      identity: formData.identity,
      password: formData.password,
    });

    if (Object.keys(vErr).length > 0) {
      setErrors({
        identity: Boolean(vErr.identity),
        password: Boolean(vErr.password),
      });
      const first =
        vErr.identity ||
        vErr.password ||
        "Please fill in all fields correctly.";
      dispatch(
        validationPopup({
          message: first,
          icon: "horror",
          type: "error",
        })
      );
      return;
    }

    dispatch(
      validationPopup({
        message: "Loading...",
        icon: "loading_ani",
      })
    );

    pbLogin(formData.identity, formData.password)
      .then((res) => {
        if (res && res.record) {
          dispatch(setUserToken(true));
          dispatch(
            validationPopup({
              message: "Successful Login",
              icon: "like",
              type: "success",
            })
          );
          navigate("/");
          onClose();
        } else {
          dispatch(
            validationPopup({
              message: "Something went wrong. Try again.",
              icon: "horror",
              type: "error",
            })
          );
          setErrors({
            identity: true,
            password: true,
          });
        }
      })
      .catch((err) => {
        const errorMessage = pocketBaseErrorMessage(err);
        dispatch(
          validationPopup({
            message: errorMessage,
            icon: "horror",
            type: "error",
          })
        );
        setErrors({
          identity: true,
          password: true,
        });
      });
  };

  return (
    <Popupz
      title="Login"
      text={
        <>
          Welcome back! <br /> Please enter your login details below.
        </>
      }
      onClose={onClose}
      popupId="login"
    >
      <div className="form-box">
        <Inputz
          iconL="username"
          focusL="username"
            label="Email or username"
          type="text"
          name="identity"
            placeholder="Email or username"
          value={formData.identity}
          onChange={handleInputChange}
          error={errors.identity}
        />

        <div>
          <Inputz
            iconL="password"
            // focusL="lock"
            iconR="eye"
            focusR="eye"
            iconOn="eye_on"
            iconOff="eye_off"
            label="Password"
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            error={errors.password}
          />
        </div>
        <div className="forget-password">
          Forgot your password?{" "}
          <a
            onClick={() => {
              onClose();
              dispatch(showForgotPasswordPopup());
            }}
          >
            Reset
          </a>
        </div>
        <div>
          <Buttonz
            iconR="login"
            hoverR="login"
            label="Login"
            onClick={handleSubmit}
          />
        </div>
      </div>

      <div>
        New member?{" "}
        <a
          onClick={() => {
            onClose();
            dispatch({ type: "SHOW_POPUP", payload: "signup" });
          }}
        >
          Signup
        </a>
      </div>
    </Popupz>
  );
}

export default LoginPopup;
